module.exports = __webpack_public_path__ + "img/tsgli-icon.d2e68eef.png";